import {clearfix, font_s_xs} from '@xpertdox_js/xdstyle';
import navbarStyles from '../styles';

export default {
  container: {
    padding: '12px 0',
    position: 'relative',
    fill: '#fafdfe',
    color: '#fafdfe',
  },
  containerHov: {
    fill: '#fff',
    background: '#36434d',
  },
  icon: {
    display: 'block',
    width: '36px',
    height: '36px',
    maxWidth: '90%',
    margin: '0 auto',
  },
  iconText: {
    ...font_s_xs,
    fontWeight: 'normal',
    // letterSpacing: '.02px',
    display: 'block',
    textAlign: 'center',
  },
  iconNavLink: {
    padding: 0,
    background: 'none',
    // position: 'absolute',
    // left: 0, top: 0, right: 0, bottom: 0,
    display: 'block',
    fill: '#fff',
    color: '#fff',
  },
  iconNavLinkHov: {
    fill: '#fff',
    color: '#fff',
  },
  iconNavLinkActive: {
    fill: '#fff',
    color: '#fff',
    padding:0,
  },
  navMenu: {
    position: 'fixed',
    width: navbarStyles.navSubContentWrap.width,
    left: '50px',
    top: 0,
    // height: '100%',
    minHeight: '100vh',
    zIndex: 1,
  },
  navMenuBottom: {
    top: 'auto',
    bottom: 0,
  },
  title: {
    margin: 0,
    padding: '10px 5px',
    background: '#36434d',
    color: '#fff',
    textAlign: 'left',
    fontSize: '18px',
    ...clearfix,
  },
  titleText: {
    float: 'left',
    width: '80%',
  },
  titleIconWrap: {
    float: 'right',
    maxWidth: '20%',
  },
  titleIcon: {
    display: 'block',
    width: '23px',
    maxWidth: '100%',
    margin: '0 auto',
  },
  navMenuContent: {
    background: navbarStyles.navSubContentWrap.background,
    borderLeft: 'none',
    height: '100vh',
    borderLeft: '1px solid rgba(0,0,0,0.12)',
    borderRight: '1px solid rgba(0,0,0,0.12)',
  },
}
